import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { DefectCompliance } from 'src/app/control/model/control.model';
import { downloadComplianceProof } from 'src/app/control/store/control.action';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatChipListbox } from '@angular/material/chips';
import { ChipProofComponent } from '../../shared/components/chips/chip-proof/chip-proof.component';

@Component({
  selector: 'sibat-control-defect-compliance-details',
  templateUrl: './control-defect-compliance-details.component.html',
  styleUrls: ['./control-defect-compliance-details.component.scss'],
  imports: [TranslocoDirective, MatIcon, MatFormField, MatLabel, MatInput, CdkTextareaAutosize, MatChipListbox, ChipProofComponent],
})
export class ControlDefectComplianceDetailsComponent {
  @Input() compliance: DefectCompliance;
  @Input() controlId: number;

  isOpen = false;

  constructor(private store: Store) {}

  onToggleDetailsClick() {
    this.isOpen = !this.isOpen;
  }

  downloadComplianceProof(proofName: string) {
    this.store.dispatch(downloadComplianceProof({ controlId: this.controlId, defectId: this.compliance.defectId, proofName }));
  }
}
